'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargePaperContract = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-paper_contract--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M42 6C45.3137 6 48 8.68629 48 12V30V42V48C48 51.3137 45.3137 54 42 54H18C14.6863 54 12 51.3137 12 48V16L22 6L42 6Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22 44H30",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22 15C22 15.5523 21.5523 16 21 16H12L22 6V15Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22 22H38",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M22 28H38",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M50.9099 25.4749C52.2767 24.108 54.4928 24.108 55.8596 25.4749C57.2265 26.8417 57.2265 29.0578 55.8596 30.4246L43.6101 42.6742L37.4749 43.8596L38.6603 37.7245L50.9099 25.4749Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M39.2427 37.1421L44.1924 42.0918",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M49.8491 26.5355L54.7989 31.4853",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-paper_contract",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M42 6C45.3137 6 48 8.68629 48 12V30V42V48C48 51.3137 45.3137 54 42 54H18C14.6863 54 12 51.3137 12 48V16L22 6L42 6Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 44H30",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 15C22 15.5523 21.5523 16 21 16H12L22 6V15Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 22H38",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 28H38",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M50.9099 25.4749C52.2767 24.108 54.4928 24.108 55.8596 25.4749C57.2265 26.8417 57.2265 29.0578 55.8596 30.4246L43.6101 42.6742L37.4749 43.8596L38.6603 37.7245L50.9099 25.4749Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M39.2427 37.1421L44.1924 42.0918",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M49.8491 26.5355L54.7989 31.4853",
                stroke: "#212121",
                strokeWidth: "1.4"
            })
        ]
    });
};
const MediumPaperContract = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("rect", {
                x: "6",
                y: "4",
                width: "26",
                height: "32",
                rx: "4",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M13 28L17 28",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M13 12H25",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M13 17H25",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M33.0208 15.1213C34.1923 13.9497 36.0918 13.9497 37.2634 15.1213C38.435 16.2929 38.435 18.1924 37.2634 19.364L28.0582 28.5691L23.1213 29.2635L23.8156 24.3265L33.0208 15.1213Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            })
        ]
    });
};
const SmallPaperContract = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        children: [
            jsxRuntime.jsx("rect", {
                x: "4",
                y: "2",
                width: "22",
                height: "28",
                rx: "4",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.2"
            }),
            jsxRuntime.jsx("path", {
                d: "M10 24H14",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M10 9H20",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M10 14H20",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M27.1372 12.5551C28.0081 11.6842 29.4201 11.6842 30.291 12.5551C31.1619 13.426 31.1619 14.8381 30.291 15.709L22.486 23.514L18.5769 24.2693L19.3322 20.3602L27.1372 12.5551Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            })
        ]
    });
};
const PaperContract = ({ size, disabled = false })=>{
    if (size === 'small') {
        return jsxRuntime.jsx(SmallPaperContract, {});
    } else if (size === 'medium') {
        return jsxRuntime.jsx(MediumPaperContract, {});
    }
    return jsxRuntime.jsx(LargePaperContract, {
        disabled: disabled
    });
};

module.exports = PaperContract;
